export default function SpecialOffer() {
  return (
    <section className="py-24 bg-gradient-to-br from-[#C9A961] to-[#B89851] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div>
            <div className="inline-block bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full text-sm font-semibold mb-6">
              Limited Time Offer
            </div>
            
            <h2 className="text-4xl sm:text-5xl font-bold mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
              Special Package Deals
            </h2>
            
            <p className="text-xl text-white/90 mb-8 leading-relaxed">
              Take advantage of our exclusive package offers on custom suits and shirts. 
              <strong className="text-white"> Save when you order multiple pieces</strong> and build your perfect wardrobe.
            </p>

            <div className="space-y-4 mb-8">
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <div>
                  <div className="font-bold text-lg">3 Suits & 3 Free Shirts</div>
                  <div className="text-white/80">Premium savings on our most popular package</div>
                </div>
              </div>

              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <div>
                  <div className="font-bold text-lg">2 Suits, 1 Sport Jacket, 1 Pair of Slacks & 3 Free Shirts</div>
                  <div className="text-white/80">Complete your wardrobe with this versatile collection</div>
                </div>
              </div>

              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <div>
                  <div className="font-bold text-lg">Free Consultation</div>
                  <div className="text-white/80">Complimentary style consultation included</div>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <a 
                href="#consultation" 
                className="inline-flex items-center justify-center bg-white text-[#C9A961] px-8 py-4 rounded-full font-bold hover:bg-gray-100 transition-all duration-300 shadow-xl whitespace-nowrap"
              >
                Call for Appointment
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <a 
                href="tel:866-857-8487" 
                className="inline-flex items-center justify-center bg-white/10 backdrop-blur-sm text-white border-2 border-white/30 px-8 py-4 rounded-full font-semibold hover:bg-white/20 transition-all duration-300 whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                Call Now
              </a>
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://www.britishtailors.com/wp-content/uploads/2016/08/current_specials-893x1024.jpg"
                alt="Current special offers on custom suits"
                className="w-full h-[600px] object-cover"
              />
            </div>

            {/* Floating Badge */}
            <div className="absolute -top-6 -right-6 bg-white rounded-full w-32 h-32 flex items-center justify-center shadow-2xl">
              <div className="text-center">
                <div className="text-3xl font-bold text-[#C9A961]">Save</div>
                <div className="text-sm font-semibold text-gray-700">Big</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}